import { isValidDate } from '../utils/isValidDate';

export const getAppEmptyResponse = city => ({ areaSlug: city });

export const buildAppData = ({
  isFavorite,
  internalLinking,
  query,
  rentableUnitData,
  listingStatistics
}) => {
  const { areaSlug, seo, listing } = rentableUnitData;
  let moveIn;
  let moveOut;

  if (query) {
    moveIn = isValidDate(query['move-in']) ? query['move-in'] : '';
    moveOut = isValidDate(query['move-out']) ? query['move-out'] : '';
  }

  const parsedOffers = listing.offers.filter(Boolean);
  return {
    areaSlug,
    seo,
    internalLinking,
    isFavorite,
    listing: {
      ...listing,
      offers: parsedOffers,
      hasOffer: !!parsedOffers.length,
      statistics: listingStatistics || {}
    },
    moveIn,
    moveOut
  };
};

export default { getAppEmptyResponse, buildAppData };
